import React, { Component } from 'react';
import axios from 'axios';
import {Link} from 'react-router-dom'
import NumberFormat from 'react-number-format';
import moment from 'moment';
import Script from 'react-load-script';
import { ToastContainer, toast } from 'react-toastify';
import {Map, InfoWindow, Polygon, GoogleApiWrapper} from 'google-maps-react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import './ProgramDetail.scss'
import Verify from '../Verify/Verify';

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


const mapStyle = [
   {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers: [
         {
         color: '#dceafa'
         }
      ]
   },
]

class ProgramDetailCarbon extends Component {
   constructor(props) {
      super(props);
      this.state = {
         loaderButton : false,
         loggedIn: false,
         loading:true,
         userType: 0,
         programId : null,
         program: [],
         featuredImage:null,
         programImages:null,
         carbonQty : 1,
         carbonGramQty : 100,
         bounds: null,
         showingInfoWindow: false,
         activeMarker:{},
         selectedPlace: {},
         selectedPaymentType : 2,
         verifiedUser : null,
         hitGetActions : 0,
         scriptLoaded : null,
         scriptError : null,
         modalConfirmation : false,
         checked : false
      };
      this.inputChangedHandler = this.inputChangedHandler.bind(this)
      this.inputChangedHandlerPersonal = this.inputChangedHandlerPersonal.bind(this)
   }
   handleCheckClick = () => {
      this.setState({ checked: !this.state.checked });
   }
   cancelOrderCarbon = (idorder) => {
      var configHeader = {
         headers: {
            'Content-Type' : 'application/json',
            'token': JSON.parse(localStorage.getItem("userData")).token
         },
      }
      axios({
         method: 'PUT',
         url: process.env.REACT_APP_API_HOST + '/order/carbon/cancel/'+idorder,
         headers: {
            "Content-Type": "application/json",
            "token": JSON.parse(localStorage.getItem("userData")).token
         }
      }).then(
         (res) => {
            console.log('res cancel carbon ', res.data)
            if(res.data.status){
               console.log('cancel order success ');
               setTimeout(() => {
                  this.getProgramDetail(this.state.programId, configHeader)
               }, 1000)
            } else {
               if(res.data.error.length){
                  for(var er = 0; er < res.data.error.length; er++){
                     var obj = res.data.error[er];
                     for (var key in obj) { 
                        console.log(key, obj[key])
                        // toast.error(obj[key]);
                     }
                  }
               } else {
                  toast.error( res.data.error );
               }
               setTimeout(() => {
                  this.getProgramDetail(this.state.programId, configHeader)
               }, 1000)
            }
         },
         (error) => {
            setTimeout(() => {
               toast.error("Error! "+  error);
               this.getProgramDetail(this.state.programId, configHeader)
            }, 1000);
         }
      );
   }
   handleScriptCreate() {
      this.setState({ scriptLoaded: false })
   }
   handleScriptError() {
      this.setState({ scriptError: true })
   }  
   handleScriptLoad() {
      this.setState({ scriptLoaded: true })
   }

   onPolygonClicked = (props, marker, e) => {
      // var latitude = e.latLng.lat();
      // var longitude = e.latLng.lng();
      // console.log('marker ', marker)
      // console.log('marker.latlngs ', marker.latLngs)
      this.setState({
         selectedPlace: props,
         activeMarker: marker,
         showingInfoWindow: true
      });
   };
   onMapClicked = (props) => {
      if (this.state.showingInfoWindow) {
         this.setState({
            showingInfoWindow: false,
            activeMarker: null
         })
      }
   };
   onInfoWindowClose = (props) => {
      this.setState({
         showingInfoWindow: false,
         activeMarker: null
      })
   };
   onInfoWindowOpen = (props) => {

   };

   getActionsByIdOrder = debounce( (programid, idorder) => {
      axios({
         method: 'GET',
         url: process.env.REACT_APP_API_HOST + '/order/actions/'+idorder,
         headers: {
            "Content-Type": "application/json",
            "token": JSON.parse(localStorage.getItem("userData")).token
         }
      }).then(
         (res) => {
            console.log('res.data actions ', res.data);
            if(res.data.status){
               if(res.data.data.token){
                  window.snap.pay(res.data.data.token, {
                     // Optional
                     onSuccess: function(result){
                        /* You may add your own js here, this is just example */ 
                        console.log('customer onSuccess ', result);
                        if(result.status_code === '200'){
                           toast.success("Sukses! Pembayaran berhasil!")
                           setTimeout(
                              function(){
                                 window.location.href = '/payment/carbon/status/'+ res.data.data.orderId;
                              }, 1000
                           )
                        }
                     },
                     // Optional
                     onPending: function(result){
                        /* You may add your own js here, this is just example */
                        console.log('customer onPending ', result);
                        setTimeout(
                           function(){
                              window.location.href = '/payment/carbon/status/' + res.data.data.orderId;
                           }, 1000
                        )
                     },
                     // Optional
                     onError: function(result){
                        /* You may add your own js here, this is just example */ 
                        console.log('customer onError ', result);
                        toast.error("Error, Pembayaran kamu terjadi kegagalan");
                     },
                     onClose: function(result){
                        console.log('customer closed the popup without finishing the payment', result);
                        console.log('order id ', res.data.data.id);
                        setTimeout(
                           function(){
                              window.location.href = '/program/carbon?id='+ programid + '&cancel='+res.data.data.id
                           }, 100
                        )
                     }
                  });
               }
            } else {
               if(this.state.hitGetActions < 60){
                  // call again
                  console.log('call again getactions ')
                  this.setState({hitGetActions : this.state.hitGetActions + 1}, () => this.getActionsByIdOrder(this.state.programId,idorder) )
               } else {
                  // error
                  setTimeout(() => {
                     this.setState({loaderButton: false, errorState:true, error:'Sorry, something went wrong.'})
                  }, 1000)
               }
            }
         },
         (error) => {
            
         }
      );
   }, 1500);
   
   confirmBuyCarbon = (index) => {
      this.setState({modalConfirmation:true});
   }

   buyCarbon = (e) => {
      e.preventDefault();
      this.setState({loaderButton:true});
      let data = {
         programId: this.state.program.id,
         totalVcu: this.state.carbonQty,
         paymentType: this.state.selectedPaymentType
      }
      axios({
         method: 'POST',
         url: process.env.REACT_APP_API_HOST + '/order/carbon/add',
         headers: {
            "Content-Type": "application/json",
            "token": JSON.parse(localStorage.getItem("userData")).token
         },
         data: data
      }).then(
         (res) => {
            console.log('res buy carbon ', res.data)
            if(res.data.status){
               if(this.state.selectedPaymentType === 0){
                  setTimeout(
                     function(){
                        window.location.href = '/payment/carbon/status/'+ res.data.data.id
                     }, 1000
                  )
               } else {
                  this.getActionsByIdOrder(this.state.program.id, res.data.data.id)
               }
            } else {
               setTimeout(() => {
                  this.setState({loaderButton: false, errorState:true, error:'Sorry, something went wrong.'})
               }, 1000)
            }
         },
         (error) => {
            setTimeout(() => {
               toast.error("Error! "+  error);
               this.setState({loaderButton:false})
            }, 1000);
         }
      );
   }

   inputChangedHandler(x) {
      if(x.floatValue !== undefined){
         if( x.floatValue > this.state.program.quota){
            this.setState({carbonQty : this.state.program.quota});
         } else if (x.floatValue === 0 ) {
            this.setState({carbonQty : 1});
         } else {
            this.setState({carbonQty : x.floatValue});
         }
      } 
   };
   inputChangedHandlerPersonal(x) {
      console.log('x personal ', x)
      if(x.floatValue !== undefined){
         if( x.floatValue > this.state.program.quota * 1000000){
            this.setState({carbonGramQty : this.state.program.quota * 1000000, carbonQty : this.state.program.quota});
         } else if (x.floatValue < 101 ) {
            this.setState({carbonGramQty : 100, carbonQty: 100 / 1000000});
         } else {
            this.setState({carbonGramQty : x.floatValue, carbonQty: x.floatValue / 1000000 });
         }
      } 
   };
   onImageClick = (props) => {
      let tag = props.currentTarget.dataset.img;
      this.setState({featuredImage: tag})
   };
   makeBounds = () => {
      var points = this.state.program.blockPolygon;
      var bounds = new this.props.google.maps.LatLngBounds();
      for (var i = 0; i < points.length; i++) {
         bounds.extend(points[i]);
      }
      this.setState({bounds})
   }
   componentDidMount() {
      const query = new URLSearchParams(this.props.location.search);
      const programId = query.get('id')
      const cancelOrder = query.get('cancel')
      console.log('cancelOrder ', cancelOrder)
      console.log('programid is ', programId)
      const userData = localStorage.getItem("userData");
      this.setState({loggedIn : false, programId:programId})
      if(userData){
         var configHeader = {
            headers: {
               'Content-Type' : 'application/json',
               'token': JSON.parse(localStorage.getItem("userData")).token
            },
         }
         console.log('usertype ', JSON.parse(userData).data.userType)
         if(JSON.parse(userData).data.userType === 0){
            this.setState({loggedIn : true, verifiedUser : JSON.parse(userData).data.verified, userType:JSON.parse(userData).data.userType, selectedPaymentType:2, carbonQty : 100 / 1000000})
         } else {
            this.setState({loggedIn : true, verifiedUser : JSON.parse(userData).data.verified, userType:JSON.parse(userData).data.userType, selectedPaymentType:0, carbonQty : 1})
         }
         const cancelSummary = new String(cancelOrder);
         console.log('cancel summary..', cancelSummary);
         console.log('cancel summary length..', cancelSummary.length);
         if(cancelOrder && cancelSummary.length > 30 && cancelSummary.length < 38 ){
            this.cancelOrderCarbon(cancelSummary)
         } else {
            this.getProgramDetail(programId, configHeader)
         }
      } else {
         var configHeader = {
            headers: {
               'Content-Type' : 'application/json',
               'token': ''
            },
         }
         this.getProgramDetail(programId, configHeader)
      }
   }

   getProgramDetail = (programId, configHeader) => {
      axios.get(process.env.REACT_APP_API_HOST + '/program/detail/carbon/'+programId, configHeader)
      .then(res => {
         console.log('res program is ', res.data)
         this.setState({ program: res.data.data, programImages : res.data.data.programImages, featuredImage: res.data.data.featuredImage, loading:false, programId : programId });
      })
   }

   _mapLoaded(mapProps, map) {
      this.makeBounds()
      console.log('map. ', map)
      map.setOptions({
         styles: mapStyle,
         mapTypeControl: false,
         mapTypeId: 'satellite'
      })
   }

   render() {
      const data = this.state.program;
      let buyButton;
      if (this.state.loggedIn) {
         if (this.state.verifiedUser === true) {
            buyButton =  <button className="btn btn-orange btn-block" onClick={this.confirmBuyCarbon}>IMBANGI KARBON</button>
         } else {
            buyButton =  <Link to="/profile" className="btn btn-orange btn-block">Verify your account!</Link>
         }
         
      } else {
         buyButton = <Link to="/login" className="btn btn-orange btn-block text-center">Login to Buy</Link>;
      }
      return (
         <div className="mpl-page cp-85">
            <Script
            url="https://app.sandbox.midtrans.com/snap/snap.js"
            attributes={{ 'data-client-key': 'SB-Mid-client-6xtIpPTnXjeq_UiJ'}}
            onCreate={this.handleScriptCreate.bind(this)}
            onError={this.handleScriptError.bind(this)}
            onLoad={this.handleScriptLoad.bind(this)}
            />
            <ToastContainer autoClose={1500}/>
            {
               this.state.loading === true ? (<div className="text-center"><div className="loader" style={{height:'24px', width:'24px', borderColor:'#00880d', borderTopColor:'#ddd', margin:'auto'}}></div></div>) : (
                  <div>
                     <div className="container">
                        <div className="row">
                           <div className="col-sm-6">
                              <img id="expandedImg" className="imageProgram" src={process.env.REACT_APP_IMG_PATH + `/deo-query/image/program/${this.state.featuredImage}`}  alt="Featured Image"/>
                              <div className="row row-narrow mt-3">
                                 {data.programImages.map(item => (
                                    <div className="col-4 mb-3" key={item}>
                                       <div className="column">
                                          <img src={process.env.REACT_APP_IMG_PATH + `/deo-query/image/program/${item}`} alt="Jejak" data-img={item} className="rounded-img" onClick={this.onImageClick}/>
                                       </div>
                                    </div>
                                 ))}
                              </div>
                           </div>
                           <div className="col-sm-6">
                              <h2 className="title-page mt-0 mb-2">
                                 {data.title}
                              </h2>
                              <h2 className="price-page text-orange text-bold mt-1 mb-2">
                              {data.currencySymbol} 
                              &nbsp;<NumberFormat value={data.sellingPrice} displayType={'text'} thousandSeparator={','} decimalSeparator={'.'} decimalScale={0}/>
                              </h2>
                              <div className="program-text-small mb-2 text-bold">
                                 Per Ton 
                              </div>
                              <br/>
                              <div className="program-text-small mb-2">
                                 <div className="row">
                                    <div className="col-auto">
                                       <div style={{width:'70px'}} className="text-gray">Penjual</div> 
                                    </div>
                                    <div className="col-auto">
                                       <span className="text-bold">{data.corporateName}</span>
                                    </div>
                                 </div>
                              </div>
                              <div className="program-text-small mb-4">
                                 <div className="row">
                                    <div className="col-auto">
                                       <div style={{width:'70px'}} className="text-gray">Lokasi</div> 
                                    </div>
                                    <div className="col-auto">
                                       <span className="text-bold">{data.province}</span>
                                    </div>
                                 </div>
                              </div>
                              
                              <div className="text-small text-gray mb-2">
                                 TERJUAL
                              </div>
                              <div className="progress-bar progress-available mb-2">
                                 <div className="progress-green" style={{width:`${ (data.carbonValue - data.quota) * 100 / data.carbonValue }%`}}> &nbsp;</div>
                              </div>
                              <div className="row">
                                 <div className="col">
                                    <div className="text-bold mt-1" style={{fontSize:'20px', lineHeight:'24px'}}>
                                       <NumberFormat value={data.carbonValue - data.quota} displayType={'text'} thousandSeparator={','} decimalSeparator={'.'} decimalScale={0}/>
                                    </div>
                                    <span className="text-small text-gray">
                                       TONNES 
                                    </span>
                                 </div>
                                 <div className="col">
                                    <div className="float-right">
                                       <div className="text-bold mt-1" style={{fontSize:'20px', lineHeight:'24px'}}>
                                          <NumberFormat value={data.carbonValue} displayType={'text'} thousandSeparator={','} decimalSeparator={'.'} decimalScale={0}/>
                                       </div>
                                       <span className="text-small text-gray">
                                          TOTAL TONNES
                                       </span>
                                    </div>
                                 </div>
                              </div>
                              <hr className="line-div"/>
                              <div className="box-buy">
                                 <div className="row">
                                    <div className="col-6">
                                       <div className="form-group">
                                          <label className="label-group" htmlFor="qty">Jumlah Karbon</label>
                                          {
                                             this.state.userType === 0 ? (
                                                <NumberFormat
                                                   id="qty" 
                                                   name="qty" 
                                                   suffix=" Gram" 
                                                   thousandSeparator={','} 
                                                   decimalSeparator={'.'} 
                                                   decimalScale={0} 
                                                   allowNegative={false} 
                                                   className="field-group text-bold" 
                                                   onValueChange={ this.inputChangedHandlerPersonal }
                                                   value={this.state.carbonGramQty}
                                                />
                                             ) : (
                                                <NumberFormat
                                                   id="qty" 
                                                   name="qty" 
                                                   suffix=" Ton" 
                                                   thousandSeparator={','} 
                                                   decimalSeparator={'.'} 
                                                   dthousandSeparator={','} 
                                                   decimalScale={0} 
                                                   allowNegative={false} className="field-group text-bold" 
                                                   onValueChange={ this.inputChangedHandler }
                                                   value={this.state.carbonQty}
                                                />
                                             )
                                          }
                                       </div>
                                    </div>
                                    <div className="col-6">
                                       <div className="form-group">
                                       <label className="label-group" htmlFor="totalPrice">Total Harga </label>
                                          {
                                             this.state.userType === 0 ? (
                                                <NumberFormat
                                                   thousandSeparator={true}
                                                   id="totalPrice" name="totalPrice" prefix={data.currencySymbol + ' '} thousandSeparator={','} decimalSeparator={'.'} decimalScale={0} className="field-group text-bold" 
                                                   value={data.sellingPrice * this.state.carbonQty} disabled
                                                />
                                             ) : (
                                                <NumberFormat
                                                   thousandSeparator={true}
                                                   id="totalPrice" name="totalPrice" prefix={data.currencySymbol + ' '} thousandSeparator={','} decimalSeparator={'.'} decimalScale={0} className="field-group text-bold" 
                                                   value={data.sellingPrice * this.state.carbonQty} disabled
                                                />
                                             )
                                          }
                                       </div>
                                    </div>
                                 </div>
                                 
                                 <div className="form-group mb-2">
                                 {data.quota === 0 ? (
                                    <React.Fragment>
                                       <button className="btn btn-block btn-disabled disabled text-uppercase" disabled style={{opacity:'.7'}}>
                                          KUOTA HABIS
                                       </button>
                                    </React.Fragment>
                                 ) : (
                                    <React.Fragment>
                                       {data.sellingPrice * this.state.carbonQty < 9999 ? (
                                          <React.Fragment>
                                             <button className="btn btn-orange btn-block" style={{opacity:'.7'}}>
                                                IMBANGI KARBON
                                             </button>
                                             <div className="text-center mt-1">
                                                <small className="text-red">Jumlah pembelian minimal Rp 10.000</small>
                                             </div>
                                          </React.Fragment>
                                       ) : (
                                          <React.Fragment>
                                             {buyButton}
                                          </React.Fragment>
                                       )}
                                    </React.Fragment>
                                 )}
                                 </div>
                              </div>
                              <div className={this.state.modalConfirmation ? 'wrap-modal show' : 'wrap-modal'} id="confirmation-popup">
                                 <div className="box-close" onClick={() => {this.setState({modalConfirmation: !this.state.modalConfirmation})}}>&nbsp;</div>
                                 <div className="box-modal">
                                    <div className="box-modal-content">
                                       <h3 className="mt-0 mb-4 font-bold">Ringkasan Pembelian</h3>
                                       <div className="row mb-3">
                                          <div className="col-4">
                                             <span className="text-gray font-semi-bold">Jumlah VCU</span>
                                          </div>
                                          <div className="col-8">
                                             <span className="font-semi-bold">
                                             {
                                             this.state.userType === 0 ? (
                                                <NumberFormat
                                                   suffix=" Gram" thousandSeparator={','} decimalSeparator={'.'} decimalScale={2} 
                                                   displayType="text"
                                                   value={this.state.carbonGramQty}
                                                />
                                             ) : (
                                                <NumberFormat
                                                   suffix=" Ton" thousandSeparator={','} decimalSeparator={'.'} decimalScale={2} 
                                                   displayType="text"
                                                   value={this.state.carbonQty}
                                                />
                                             )
                                          }
                                             </span>
                                          </div>
                                       </div>
                                       <div className="row mb-3">
                                          <div className="col-4">
                                             <span className="text-gray font-semi-bold">Harga</span>
                                          </div>
                                          <div className="col-8">
                                             <span className="tx-bold font-semi-bold">
                                             {
                                                this.state.userType === 0 ? (
                                                   <NumberFormat
                                                      thousandSeparator={true}
                                                      displayType="text"
                                                      prefix={data.currencySymbol + ' '}
                                                      thousandSeparator={','} 
                                                      decimalSeparator={'.'} 
                                                      decimalScale={0} 
                                                      value={data.sellingPrice * this.state.carbonQty} 
                                                   />
                                                ) : (
                                                   <NumberFormat
                                                      thousandSeparator={true}
                                                      displayType="text"
                                                      prefix={data.currencySymbol + ' '} 
                                                      thousandSeparator={','} 
                                                      decimalSeparator={'.'} 
                                                      decimalScale={0} 
                                                      value={data.sellingPrice * this.state.carbonQty} 
                                                   />
                                                )
                                             }
                                             </span>
                                          </div>
                                       </div>
                                       {
                                          data.selectedIncludeTax ? (null) : (
                                             <div className="row mb-3">
                                                <div className="col-4">
                                                   <span className="text-gray font-semi-bold">PPN</span>
                                                </div>
                                                <div className="col-8">
                                                   <span className="tx-bold font-semi-bold">
                                                   <NumberFormat
                                                   suffix={'%'} thousandSeparator={','} decimalSeparator={'.'}
                                                      value={data.addedTaxPercentage} displayType="text"
                                                   />
                                                   </span>
                                                </div>
                                             </div>
                                          )
                                       }
                                       <div className="line mt-5"></div>
                                       <span>
                                          Total Tagihan
                                       </span>
                                       <div>
                                          {
                                             data.selectedIncludeTax ? (
                                                <h2 className="tx-orange mt-2 font-bold">
                                                   {
                                                   this.state.userType === 0 ? (
                                                      <NumberFormat
                                                         thousandSeparator={true}
                                                         displayType="text"
                                                         prefix={data.currencySymbol + ' '}
                                                         thousandSeparator={','} 
                                                         decimalSeparator={'.'} 
                                                         decimalScale={0} 
                                                         value={data.sellingPrice * this.state.carbonQty} 
                                                      />
                                                   ) : (
                                                      <NumberFormat
                                                         thousandSeparator={true}
                                                         displayType="text"
                                                         prefix={data.currencySymbol + ' '} 
                                                         thousandSeparator={','} 
                                                         decimalSeparator={'.'} 
                                                         decimalScale={0} 
                                                         value={data.sellingPrice * this.state.carbonQty} 
                                                      />
                                                   )
                                                }
                                                </h2>
                                             ) : (
                                                <h2 className="tx-orange mt-2 font-bold">
                                                   {
                                                      this.state.userType === 0 ? (
                                                         <NumberFormat
                                                            thousandSeparator={true}
                                                            displayType="text"
                                                            prefix={data.currencySymbol + ' '}
                                                            thousandSeparator={','} 
                                                            decimalSeparator={'.'} 
                                                            decimalScale={0} 
                                                            value={data.sellingPrice * this.state.carbonQty + (data.sellingPrice * this.state.carbonQty * data.addedTaxPercentage / 100)} 
                                                         />
                                                      ) : (
                                                         <NumberFormat
                                                            thousandSeparator={true}
                                                            displayType="text"
                                                            prefix={data.currencySymbol + ' '} 
                                                            thousandSeparator={','} 
                                                            decimalSeparator={'.'} 
                                                            decimalScale={0} 
                                                            value={data.sellingPrice * this.state.carbonQty + (data.sellingPrice * this.state.carbonQty * data.addedTaxPercentage / 100)} 
                                                         />
                                                      )
                                                   }
                                                </h2>
                                             )
                                          }
                                       </div>
                                       <br/>
                                       <div className="mb-3">
                                          <label htmlFor="termCondition" className="term-condition">
                                             <input id="termCondition" type="checkbox" checked={this.state.checked} onChange={this.handleCheckClick}/>
                                             &nbsp; <small>Saya setuju dengan <Link target={"_blank"} to="/term-conditions">syarat & ketentuan</Link></small>
                                          </label>
                                       </div>
                                       {
                                          this.state.loaderButton ? (
                                             <button className="btn btn-orange btn-block" style={{opacity:'.7'}}><div className="loader"></div></button>
                                          ) : (
                                             <React.Fragment>
                                                {this.state.checked ? (
                                                   <button className="btn btn-orange btn-block" onClick={this.buyCarbon}>BAYAR</button>
                                                ) : (
                                                   <button className="btn btn-orange btn-block" style={{opacity:'.7'}}>BAYAR</button>
                                                )}
                                             </React.Fragment>
                                          )
                                       }
                                       
                                    </div>
                                 </div>
                              </div> 

                           </div>
                           <div className="col-sm-12">
                              <hr className="line-div"/>
                              <div className="program-general mt-2">
                                 <div className="program-detail-tab">
                                    <Tabs>
                                       <TabList>
                                          <Tab>Deskripsi Program</Tab>
                                       </TabList>
                                    
                                       <TabPanel>
                                          <div className="program-tab-description mt-4">
                                             <div dangerouslySetInnerHTML={{ __html: data.description }} />
                                             <br/>
                                          </div>
                                          <br/>
                                    
                                          <div className="wrap-relative">
                                             <h3>Lokasi Program</h3>
                                             <Map 
                                                google={this.props.google} 
                                                className={'map'}
                                                onReady={(mapProps, map) => this._mapLoaded(mapProps, map)}
                                                bounds={this.state.bounds}
                                                onClick={this.onMapClicked}>
                                                <Polygon
                                                   paths={this.state.program.blockPolygon}
                                                   strokeColor="#0000FF"
                                                   strokeOpacity={0.8}
                                                   strokeWeight={2}
                                                   fillColor="#0000FF"
                                                   fillOpacity={0.1} 
                                                   blockLocationName={this.state.program.blockLocationName}
                                                   area={this.state.program.area}
                                                   fillOpacity={0.1} 
                                                   onClick={this.onPolygonClicked}/>
                                                   <InfoWindow
                                                   marker={this.state.activeMarker}
                                                   position={this.state.bounds}
                                                   onOpen={this.onInfoWindowOpen}
                                                   onClose={this.onInfoWindowClose}
                                                   visible={this.state.showingInfoWindow}>
                                                      <div>
                                                      <b>{this.state.selectedPlace.blockLocationName}</b>
                                                      <p>
                                                      <NumberFormat value={this.state.selectedPlace.area} displayType={'text'} thousandSeparator={true} decimalScale={0}/> &nbsp; Hectare</p>
                                                      </div>
                                                   </InfoWindow>
                                             </Map>
                                          </div>
                                          <br/>
                                          <br/>
                                          <br/>
                                          <h3>Daftar Spesies Pohon</h3>
                                          <div className="tb-header">
                                             <div className="tbr-flex">
                                                <div className="tbc-flex">
                                                   Nama pohon
                                                </div>
                                                <div className="tbc-flex">
                                                   Nama latin
                                                </div>
                                                <div className="tbc-flex">
                                                   Jumlah Pohon
                                                </div>
                                             </div>
                                          </div>
                                          <div className="tb-body">
                                             {data.treeSummaries.map( (item, index) => (
                                             <div className="tbr-flex" key={index}>
                                                <div className="tbc-flex">
                                                   {item.treeName}
                                                </div>
                                                <div className="tbc-flex">
                                                   {item.treeBinomialName}
                                                </div>
                                                <div className="tbc-flex">
                                                   {item.total}
                                                </div>
                                             </div>
                                             ))}
                                          </div>
                                       </TabPanel>
                                    </Tabs>
                                    
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               )
            }
         </div>
         )
      }
   }

   export default GoogleApiWrapper({
      apiKey: ('AIzaSyCS9mdO4o_M7sv8ONF9Ft0CQaWoGuk6Ay8')
    })(ProgramDetailCarbon)